'use strict'

const getters = {
  internalFleet: state => {
    return Object.values(state.data).filter(vehicle => vehicle.is_internal === true)
  },
  externalFleet: state => {
    return Object.values(state.data).filter(vehicle => vehicle.is_internal === false)
  },
  getVehicleByID: (state, vehicleId) => {
    return state.data[vehicleId]
  }
}

export default getters
